import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { $integrationsStore } from './integrationsStore';
import { type ConfirmConnectRequest, IntegrationsApi, IntegrationStep, IntegrationType } from '@shared/api';

const connectEffect = createEffect((request: IntegrationType) => IntegrationsApi.connect(request));
connectEffect.done.watch((data) => {
  if (data.result.data?.redirectUrl) window.location.href = data.result.data?.redirectUrl;
});
const disconnectEffect = createEffect((request: IntegrationType) => IntegrationsApi.disconnect(request));
disconnectEffect.done.watch(() => $integrationsStore.events.getIntegrations());
const confirmConnectEffect = createEffect((request: ConfirmConnectRequest) => IntegrationsApi.confirmConnect(request));
const clearEvent = createEvent();

const $dataStore = createStore<IntegrationStep>(IntegrationStep.None)
  .on(connectEffect.pending, (current, data) => {
    if (data) return IntegrationStep.Connect;
    return current;
  })
  .on(confirmConnectEffect.pending, (current, data) => {
    if (data) return IntegrationStep.Confirm;
    return current;
  })
  .on(confirmConnectEffect.done, () => IntegrationStep.Confirmed)
  .on(confirmConnectEffect.fail, () => IntegrationStep.Connect)
  .on(disconnectEffect.pending, (current, data) => {
    if (data) return IntegrationStep.Disconnect;
    return current;
  })
  .on(disconnectEffect.done, () => IntegrationStep.None)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(confirmConnectEffect.pending, (_, data) => data)
  .on(confirmConnectEffect.fail, () => false)
  .on(confirmConnectEffect.done, () => false)
  .on(connectEffect.pending, (_, data) => data)
  .on(connectEffect.fail, () => false)
  .on(connectEffect.done, () => false)
  .on(disconnectEffect.pending, (_, data) => data)
  .on(disconnectEffect.fail, () => false)
  .on(disconnectEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(confirmConnectEffect, () => null)
  // .on(confirmConnectEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(confirmConnectEffect.fail, () => 'Something went wrong while confirming Integration. Please try again.')
  .on(confirmConnectEffect.done, () => null)
  .on(connectEffect, () => null)
  // .on(connectEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  // .on(connectEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(connectEffect.fail, () => 'Something went wrong while connecting Integration. Please try again.')
  .on(connectEffect.done, () => null)
  .on(disconnectEffect, () => null)
  // .on(disconnectEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(disconnectEffect.fail, () => 'Something went wrong while disconnecting Integration. Please try again.')
  .on(disconnectEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $connectionStore = {
  events: {
    connect: connectEffect,
    confirmConnect: confirmConnectEffect,
    disconnect: disconnectEffect,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
